const labels: Record<string, string> = {
  summary: 'Результат', result_summary: 'Результат', message: 'Сообщение',
  title: 'Название', description: 'Описание', value: 'Значение',
  result: 'Результат', results: 'Результаты', count: 'Количество',
  sample_size: 'Размер выборки', mean: 'Среднее', median: 'Медиана',
  standard_deviation: 'Стандартное отклонение', confidence_interval: 'Доверительный интервал',
  lower: 'Нижняя граница', upper: 'Верхняя граница', p_value: 'Значимость',
  recommendations: 'Рекомендации', warnings: 'Замечания', conclusion: 'Вывод',
  interpretation: 'Пояснение', filename: 'Файл', input_filename: 'Исходный файл',
};

const internalFields = new Set([
  'id', 'tool_id', 'tool_key', 'author_user_id', 'user_id', 'request_id',
  'schema_version', 'checksum', 'model', 'prompt', 'input_parameters',
]);

export function ResultDetails({ value }: { value: unknown }) {
  if (value === null || value === undefined) return <span>Не указано</span>;
  if (typeof value === 'boolean') return <span>{value ? 'Да' : 'Нет'}</span>;
  if (Array.isArray(value)) {
    return <ul>{value.map((item, index) => <li key={index}><ResultDetails value={item} /></li>)}</ul>;
  }
  if (typeof value === 'object') {
    const entries = Object.entries(value).filter(([key]) => !internalFields.has(key));
    return <dl>{entries.map(([key, item], index) => <div key={key}>
      <dt>{labels[key] || (/[а-яё]/i.test(key) ? key : `Показатель ${index + 1}`)}</dt>
      <dd><ResultDetails value={item} /></dd>
    </div>)}</dl>;
  }
  return <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{String(value)}</span>;
}
